
const collectionInboxes = [
    {
        "uuid":"1",
        "createdOn":"2021-07-02T08:20:10.000Z",
        "appType":"initial",
        "phase":"documentCheck",
        "activity":"documentCheck_S10",
        "customerNo":"00001",
        "customerName":"源天然股份有限公司",
        "assessmentPlaces":[
            {"assessmentPlace":"台東廠", "productionLineCount":2, "productCount":5, "semiProductCount":1, "lezzenProductCount":5,"inspectionManDay":1.5 },
            {"assessmentPlace":"屏東廠", "productionLineCount":1, "productCount":7, "semiProductCount":1, "lezzenProductCount":3, "inspectionManDay":1 }
        ],
        "no":"R21081201",
        "applyDate":"2021-07-02T08:20:10.000Z",
        "allSupplements":[
            {"nodeId":"1_assessmentProduct", "category":"評鑑產品","item":"杏仁玄米餅","subItem":"豆蓉粉(新版)", "comments":"原料H-牛蒡片005(牛蒡片)(使用於成品黑豆牛蒡茶、牛蒡養生茶、人參黃耆茶、黑豆牛蒡茶包)\n" +
                    "(1)檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明。\n" +
                    "(2)所提供之外標示照片無供應商及製造商可與明細表長昇蔘藥行有限公司勾稽，請重新提供標示照片(或提供進貨單據)",
            "completedDate":"2021-07-21T08:20:10.000Z",
            "reviewHistories":[
                {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"},
                {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-20T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"}
            ]},
            {"nodeId":"4_assessmentProduct", "category":"評鑑產品","item":"Natural Benefits 食安生技-椰子汁", "comments":"1.跟零食一樣爽脆、熱量只有1/20！吃西洋芹紓壓解熱還能補足多種營養 2.請附輸入食品許可通知",
                "completedDate":"2021-07-22T08:20:10.000Z",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"已根據要求說明"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true}
                ]},
            {"nodeId":"3_assessmentProduct", "category":"評鑑產品", "item":"桂圓四物飲","subItem":"美國加州杏仁果","comments":"原料H-紅茶葉119(金洋):(使用於成品女兒紅茶、女兒紅茶包)\n" +
                    "(1)所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽。且明細表及外標示亦無法和輸入許可證的報驗義務人原津股份有限公司勾稽，請確認並重新提供。\n" +
                    "(2)檢驗報告也無法勾稽且已過期一年，請說明。\n" +
                    "(3)外標示照片無供應商金洋可勾稽，請重新提供標示照片(或提供進貨單據)",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"已根據要求說明"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true}
                ]}
        ],
        "newSupplementItems":[
            {"nodeId":"3_assessmentProduct", "category":"評鑑產品", "item":"桂圓四物飲","subItem":"美國加州杏仁果","comments":"原料H-紅茶葉119(金洋):(使用於成品女兒紅茶、女兒紅茶包)\n" +
                    "(1)所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽。且明細表及外標示亦無法和輸入許可證的報驗義務人原津股份有限公司勾稽，請確認並重新提供。\n" +
                    "(2)檢驗報告也無法勾稽且已過期一年，請說明。\n" +
                    "(3)外標示照片無供應商金洋可勾稽，請重新提供標示照片(或提供進貨單據)"},
        ],
        "remainingDays":-1
    },
    {
        "uuid":"3",
        "createdOn":"2021-07-04T08:20:10.000Z",
        "applyDate":"2021-07-03T08:20:10.000Z",
        "appType":"initial",
        "phase":"documentCheck",
        "activity":"documentCheck_S30",
        "customerNo":"00003",
        "customerName":"福星食品有限公司",
        "no":"R21081501",
        "urgent":true,
        "urgentDesc":"期望文審完成日期3月底完成、查驗日期4月底完成、產品上架日期8月初",
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1000
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2000
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100
            }
        ],
        "assessmentPlaces":[
            {"assessmentPlace":"台東廠", "productionLineCount":2, "productCount":5, "semiProductCount":1, "lezzenProductCount":5,"inspectionManDay":1.5 },
            {"assessmentPlace":"屏東廠", "productionLineCount":1, "productCount":7, "semiProductCount":1, "lezzenProductCount":3, "inspectionManDay":1 }
        ],
        "remainingDays":3
    },
    {
        "uuid":"4",
        "createdOn":"2021-07-05T08:20:10.000Z",
        "applyDate":"2021-07-02T08:20:10.000Z",
        "appType":"initial",
        "phase":"documentCheck",
        "activity":"documentCheck_S40",
        "customerNo":"00004",
        "customerName":"黑松股份有限公司",
        "no":"R21081311",
        "urgent":true,
        "urgentDesc":"期望文審完成日期3月底完成、查驗日期4月底完成、產品上架日期8月初",
        "assessmentPlaces":[
            {"assessmentPlace":"台東廠", "productionLineCount":2,"productCount":5,  "semiProductCount":1, "lezzenProductCount":5,"inspectionManDay":1.5 },
            {"assessmentPlace":"屏東廠", "productionLineCount":1,"productCount":7,  "semiProductCount":1, "lezzenProductCount":3, "inspectionManDay":1 }
        ],
        "existCustomers":["leezen"],
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1500,
                "adjustment":"評鑑產品超多"
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2000
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100
            },
            {
                "item":"合計",
                "amountDefault":6600,
                "amountModified":7100
            }
        ],
        "remainingDays":5
    },
    {
        "uuid":"5",
        "createdOn":"2021-07-06T08:20:10.000Z",
        "applyDate":"2021-07-02T08:20:10.000Z",
        "appType":"initial",
        "phase":"documentCheck",
        "activity":"documentCheck_S50",
        "customerNo":"00101",
        "customerName":"中農粉絲有限公司",
        "no":"R21081305",
        "urgent":true,
        "urgentDesc":"期望文審完成日期3月底完成、查驗日期4月底完成、產品上架日期8月初",
        "assessmentPlaces":[
            {"assessmentPlace":"台東廠", "productionLineCount":2,"productCount":5,  "semiProductCount":1, "lezzenProductCount":5,"inspectionManDay":1.5 },
            {"assessmentPlace":"屏東廠", "productionLineCount":1,"productCount":7,  "semiProductCount":1, "lezzenProductCount":3, "inspectionManDay":1 }
        ],
        "existCustomers":["leezen"],
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1500,
                "adjustment":"評鑑產品超多"
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2000
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100
            },
            {
                "item":"合計",
                "amountDefault":6600,
                "amountModified":7100
            }
        ],
        "remainingDays":5
    },
    {
        "uuid":"6",
        "createdOn":"2021-07-07T08:20:10.000Z",
        "applyDate":"2021-07-05T08:20:10.000Z",
        "appType":"initial",
        "phase":"documentCheck",
        "activity":"documentCheck_S60",
        "customerNo":"00061",
        "customerName":"我的輕食有限公司",
        "no":"R21081306",
        "urgent":true,
        "urgentDesc":"期望文審完成日期3月底完成、查驗日期4月底完成、產品上架日期8月初",
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1000
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2100
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100
            }
        ],
        "assessmentPlaces":[
            {"assessmentPlace":"台東廠", "productionLineCount":2, "productCount":5, "semiProductCount":1, "lezzenProductCount":5,"inspectionManDay":1.5 },
            {"assessmentPlace":"屏東廠", "productionLineCount":1, "productCount":7, "semiProductCount":1, "lezzenProductCount":3, "inspectionManDay":1 }
        ],
        "remainingDays":6
    }
]

export default collectionInboxes;